import { NgModule } from '@angular/core';
import { DocumentsListComponent } from '@app/documents/documents-list/documents-list.component';
import { PrimeNgModule } from '@shared/primeng/prime-ng.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LibPipeModule } from '@mynexus/mynexus-ui-lib';
import { EditDateTimeComponent } from './edit-date-time/edit-date-time.component';

@NgModule({
  declarations: [DocumentsListComponent, EditDateTimeComponent],
  imports: [
    CommonModule,
    FormsModule,
    LibPipeModule,
    PrimeNgModule
  ],
  exports: [DocumentsListComponent]
})
export class DocumentsListModule { }
